const getFormState = state => state.formStateReducer;

export const getIsFormDirty = state =>  getFormState(state).isFormDirty;